class PebbleSearchPanel extends HTMLElement {
  constructor() {
    super();
    this.onDocumentKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    };
  }

  connectedCallback() {
    this.headerSection = document.querySelector('#shopify-header-section');
    this.panelInput = this.querySelector('.header-pebble-search-panel__input');

    document.querySelectorAll('[data-pebble-search-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.querySelectorAll('[data-pebble-search-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', this.onDocumentKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  isOpen() {
    return this.headerSection?.classList.contains('header--pebble-search-open');
  }

  open() {
    if (!this.headerSection) return;

    this.headerSection.classList.add('header--pebble-search-open');
    document.body.classList.add('pebble-search-open');
    this.setAttribute('aria-hidden', 'false');

    const searchIcon = document.querySelector('.header-pebble-search-icon');
    if (searchIcon) {
      searchIcon.setAttribute('aria-expanded', 'true');
    }

    requestAnimationFrame(() => {
      this.panelInput?.focus();
    });
  }

  close() {
    if (!this.headerSection) return;

    const searchBar = this.querySelector('search-bar');
    if (searchBar) {
      const input = searchBar.querySelector('input');
      if (input) input.value = '';

      const emptyState = searchBar.querySelector('.search-bar__empty');
      const result = searchBar.querySelector('.search-bar__result');
      if (emptyState) emptyState.classList.remove('hide');
      if (result) result.classList.add('hide');
    }

    this.headerSection.classList.remove('header--pebble-search-open');
    document.body.classList.remove('pebble-search-open');
    this.setAttribute('aria-hidden', 'true');

    const searchIcon = document.querySelector('.header-pebble-search-icon');
    if (searchIcon) {
      searchIcon.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('header-search-panel')) {
  customElements.define('header-search-panel', PebbleSearchPanel);
}
